import React, {Fragment} from "react";
import Button from "./Button";
import classNames from 'classnames';
import ComponentConfig from "./ComponentConfig";
import {connect} from "src/store";
import {setContent} from "./../../actions/index";
import {ComponentFormatter} from "../../utils/formatters";
import Icon from "./Icon";

export const componentEditors = {
    WriteOff: "WriteOffs",
    MoneyTransfer: "TransactionPayment"
}

export default connect(() => ({}),{setContent})((props) => {
    const button = (cprops) => <Button
        block={props.block !== undefined ? props.block : true}
        color="default"
        className={classNames("details-button", props.className, {"icon-type": props.icon})}
        disabled={props.disabled || !cprops.componentConfig}
        size={props.icon ? "xs" : null}
        tooltip={props.icon ? <Fragment>{ComponentFormatter({component: props.component_type, def: props.def})} adatai</Fragment> : null}
        onClick={() => {
            if (cprops.componentConfig) {
                props.setContent(componentEditors[props.component_type] || props.component_type, {[cprops.componentConfig.idfield]: props.component_id});
            }
        }}
    >
        {!cprops.componentConfig ? <Fragment>&nbsp;</Fragment> : (props.icon ? (props.icon !== true ? (props.icon instanceof Object ? (props.icon.type ? <props.icon.type {...props.icon.props} /> : <Icon {...props.icon} />) : <Icon name={props.icon} />) : <Icon lib="fas" name="share"/>) : <Fragment>{props.component_id ? <Fragment>{props.component_id} </Fragment> : null}{ComponentFormatter({component: props.component_type, def: props.def})} adatai</Fragment>)}
    </Button>;
    return <Fragment>
        {props.label !== false && !props.icon && <label className="control-label">&nbsp;</label>}
        {props.component_type ? <ComponentConfig componentName={props.component_type} loader={button}>
            {button}
        </ComponentConfig> : button}
    </Fragment>
});